import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'
import cx from 'classnames'
import { ArticleFileIcon } from 'components/ArticleFileIcon/ArticleFileIcon'
import { MentionPrompt, ObjectsToLoad } from 'proseShared/prompts/MentionPrompt/MentionPrompt'
import { ArticleFlat } from 'types'
import { TextInputField } from '../../Form/TextInputField'
import Styles from './AssetInput.module.scss'
import { linkBottomLabel } from './urlValidationUtils'

interface AssetInputProps {
  selectedDoc?: ArticleFlat | null
  handleExternalLinkChange: (event: any) => void
  externalLink: string
  isEmbeddable: boolean
  externalLinkValid: boolean | string
  onDeselectDoc: () => void
  onDocSelected: (doc: ArticleFlat) => void
}

export const AssetInput = ({
  selectedDoc,
  handleExternalLinkChange,
  externalLink,
  isEmbeddable,
  externalLinkValid,
  onDeselectDoc,
  onDocSelected,
}: AssetInputProps) => {
  return (
    <div className={Styles.v2}>
      <TextInputField
        autoFocus
        labelClassName={Styles.inputLabel}
        placeholder={!!selectedDoc ? '' : 'Add a link to a file or search for a doc'}
        label="Link or doc"
        aria-label="Select File"
        onChange={handleExternalLinkChange}
        value={externalLink}
        wrapperClassName={cx(Styles.linkInput, {
          [Styles.disabled]: !!selectedDoc,
          [Styles.valid]: externalLinkValid,
        })}
        size="lg"
      />
      {!!selectedDoc && (
        <div className={Styles.selectedDoc}>
          <div className={Styles.docIconWrapper}>
            <ArticleFileIcon customClassName={Styles.docIcon} article={selectedDoc} />
          </div>
          <div className={Styles.docTitle}>{selectedDoc.title}</div>
          <CloseIcon className={Styles.close} onClick={onDeselectDoc} />
        </div>
      )}
      {!externalLinkValid && (
        <>
          <MentionPrompt
            inputQuery={externalLink}
            suggestRecentlyReadArticle={false}
            allowCreateNewFile={false}
            onSelect={(doc) =>
              onDocSelected({
                title: doc.title,
                header_emoji: doc.header_emoji,
                id: doc.key,
              } as ArticleFlat)
            }
            dropdownWidth={'100%'}
            objectsToLoad={[ObjectsToLoad.Articles]}
            overrideContainerClassname={Styles.mentionPrompt}
            availableForReview
          />
          <label className={Styles.bottomLabel}>{linkBottomLabel()}</label>
        </>
      )}
    </div>
  )
}
